export default `
  query customerCartId {
    customerCart {
      id
    }
  }
`;
